import React, { useState } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import logo from './assets/images/elevate-logo.svg';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

const [backdropVisible, setBackdropVisible] = useState(true);

const handleMenuItemClick = () => {
  setMenuOpen(!menuOpen);
  setBackdropVisible(!backdropVisible);
};

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          <img src={logo} alt="Logo" className="elevate-logo img-fluid" />
        </a>
        <button className={`navbar-toggler ${menuOpen ? 'close-icon' : ''}`} onClick={handleMenuToggle} type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className={`offcanvas offcanvas-start ${menuOpen ? 'show' : ''}`} tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
          <div className="offcanvas-header">
            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
              <li className="nav-item" data-bs-dismiss="offcanvas">
                <NavLink className="nav-link" to="/" onClick={handleMenuItemClick} >
                  Home
                </NavLink>
              </li>
              <li className="nav-item" data-bs-dismiss="offcanvas">
                <NavLink className="nav-link" to="/about-us"  onClick={handleMenuItemClick}>
                  About Us
                </NavLink>
              </li>

              <li className="nav-item" data-bs-dismiss="offcanvas">
                <NavLink className="nav-link" to="/services">
                  Services
                </NavLink>
              </li>

              <li className="nav-item" data-bs-dismiss="offcanvas">
                <NavLink className="nav-link" to="/solutions">
                  Solutions
                </NavLink>
              </li>

              <li className="nav-item" data-bs-dismiss="offcanvas">
                <NavLink className="nav-link" to="/resources">
                  Resources
                </NavLink>
              </li>

              <li className="nav-item" data-bs-dismiss="offcanvas">
                <NavLink className="nav-link" to="/contact-us">
                  Contact Us
                </NavLink>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </nav>
    
  );
}

export default Navigation;
